<div class="container-filter" matMenuContent (click)="$event.stopPropagation()">
  <div class="search-filter">
    <input
      class="search-filter__input"
      type="text"
      placeholder="Pesquisar por nome"
      (input)="onBuscaChange($event)"
    />
    <mat-icon class="search-filter__icon" svgIcon="magnify"></mat-icon>
  </div>

  <div class="item-filter container-filter__padding">
    <div class="lista">
      <div class="item" *ngFor="let usuario of filteredUsuarios">
        <mat-checkbox
          color="primary"
          [ngModel]="isUsuarioAtivo(usuario)"
          (ngModelChange)="onFiltroChange(usuario)"
          labelPosition="before"
        >
          <div class="container-nome">
            <img
              [src]="usuario.img"
              onError="this.src='assets/img/usuarioAnonimo.png'"
            />
            <span class="filter-text">{{ usuario.nome }}</span>
          </div></mat-checkbox
        >
      </div>
    </div>
  </div>
</div>
